
import { Component, OnInit, Input,Output,EventEmitter,AfterViewInit,ViewChild} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ICompanySpecificInfo } from "app/company-offers/services/icompany-specific-info";
import * as emiGlobals from 'app/globals';
import { LoanOfferGenService } from "app/loan/services/loan-offer-gen.service";
import { NgbTabChangeEvent,NgbCarousel } from "@ng-bootstrap/ng-bootstrap";
import {NgbTabset} from "@ng-bootstrap/ng-bootstrap";
import {Router, ActivatedRoute, Params,NavigationExtras,NavigationCancel } from '@angular/router';



@Component({
  selector: 'hl-form',
  templateUrl: './hl-form.component.html',
  styleUrls: ['./hl-form.component.css'],
})

export class HlFormComponent implements OnInit, AfterViewInit  {

  extra;
  defaultQuoteLoanAmount = "50,00,000";
  @Input() type;
  @Input() otheroffer;
  @Output() onClickOfLoanEligibility: EventEmitter<any> = new EventEmitter();
  

  active;
  selectedTab:string; 

  @ViewChild('selectTab') private tabs:NgbTabset;
  @ViewChild('selectTabweb') private tabWeb:NgbTabset;
  hide_personalize=true;
  more_personalize_mobile=false;
  x=true; 
  loanApplyForm : FormGroup;
  companyInfo:ICompanySpecificInfo;
   show_alert_message:boolean=true;
  is_co_applicant_enabled:boolean=false;
  more_personalize:boolean= false;
  title="Personalise my offers";
  hide_on_mobile:boolean=true;
  hide_on_desktop:boolean=true;
  noResultsTerm: string = '';
  //type = emiGlobals.HomeLoan_New;
  company_selected;
  company_values = [
    // { id: 1074, name: 'TECH MAHINDRA' },
    // { id: 7055, name: '24/7 CUSTOMER' },
    // { id: 826, name: 'ORACLE SOFTWARE I PVT LTD' },
    // { id: 1052, name: 'TATA CONSULTANCY SERVICES' },
  ];

  options_locations =this.loanOfferService.getCityList();
  options_bank=this.loanOfferService.getBankList();
  // options_bank = emiGlobals.SalaryBankEnum;
  options_gender = emiGlobals.GenderEnum;
  option_loan_tenure = emiGlobals.HLLoanTenureEnum;
  option_workexp = emiGlobals.WorkExperienceEnum;
  option_co_employment_type = emiGlobals.HLEmploymentTypeEnum;

  HLNew = emiGlobals.HomeLoan_New;
  HLBt = emiGlobals.HomeLoan_Transfer;
  HLBtSave = "HomeSaver";
  activePanel = emiGlobals.HomeLoan_New;
  loan_amount_label = "Loan Amount";

  loan_amount_generated=false;
  dataToApi;
  current_appicant="Applicant";

  AppEmpType = { 
    status:"Salaried",
    show_company:true,
    show_bonus:true,
    show_depresation:false,
    show_nature:false,
    bank_title:"Salary Account Bank",
    income_title:"Net Salary Per Month",
  };
  
  CoAppEmpType = { 
    status:"Salaried",
    show_company:true,
    show_bonus:true,
    show_depresation:false,
    show_nature:false,
    bank_title:"Salary Account Bank",
    income_title:"Net Salary Per Month",
  };

  constructor(
    private fb: FormBuilder,
    private loanOfferService:LoanOfferGenService,
    private route: ActivatedRoute,
    public router:Router
  ) {
    
   }

  ngOnInit() {
    console.log(this.type);
    // this.company_selected={name: "Utthishta Management Advisors Llp", id: "123017", $order: 2}
    this.extra = this.route
    .queryParams
    .subscribe(params => {
      if(Object.keys(params).length>0){
          this.setUrlParametersToLocal(params);
          this.loanOfferService.checkHasLocalData();
          this.buildForm();
          if(params.generate_quote=="true"){
               this.generateOffer(params)
            }
       }else{
        this.loanOfferService.checkHasLocalData();
        this.buildForm();
       }
    });
  
     this.activePanel =  this.type;
     if(this.activePanel == emiGlobals.HomeLoan_Transfer){
      this.loan_amount_label = "Loan Outstanding";
    }
     this.loanOfferService.updateCustomerInfoData({
              "loan_type":this.type,
            });
    this.active=this.type;
    
  }

 
  ngAfterViewInit(){
    if(this.tabs) {
      this.tabs.select(this.active);
    }
    if(this.tabWeb){
      this.tabWeb.select(this.active);
    }
    
    this.onAppEmploymentChange(this.getFielsDefaultValue('emp_type_id',0));
    this.onCoAppEmploymentChange(this.getFielsDefaultValue('coemp_type_id',0));
   
  }
  ngOnDestroy(): void {
    if(this.extra) {
    this.extra.unsubscribe(); }
}
  buildForm(){

        this.loanApplyForm = this.fb.group({

        'netsal': [this.getFielsDefaultValue('netsalary','35000'), Validators.compose([Validators.required, Validators.minLength(3)])],
        'ex_emi':[this.getFielsDefaultValue('existing_emi','5000'), Validators.compose([Validators.required])],
        'bank':[this.getFielsDefaultValue('salary_bank_account_id',0), Validators.compose([Validators.required])],
        'workexp':[this.getFielsDefaultValue('work_exp_id',3), Validators.compose([Validators.required])],
        'age':[this.getFielsDefaultValue('age',28), Validators.compose([Validators.required])],
        'city':[this.getFielsDefaultValue('location_id',0), Validators.compose([Validators.required])],
        'gender':[this.getFielsDefaultValue('gender_id',0), Validators.compose([Validators.required])],

        'sal':[this.getFielsDefaultValue('emp_type_id',0), Validators.compose([Validators.required])],
        'company':[null],
        'purp':[this.getPurposeCode(), Validators.compose([Validators.required])],
        'bonus':[this.getFielsDefaultValue('bonus',0)],
        'nature':[this.getFielsDefaultValue('nature','Engineer')],
        'loanamt':[this.getFielsDefaultValue('loan_amount',5000000), Validators.compose([Validators.required])],
        'tenure':[17, Validators.compose([Validators.required])],
        'propval' :[this.getFielsDefaultValue('propvalue',3000000),Validators.compose([Validators.required])],

        'cosal'   :this.getFielsDefaultValue('coemp_type_id',0),
        'cobank'  :[this.getFielsDefaultValue('cobank_id',0)],
        'cogender':[this.getFielsDefaultValue('cogender_id','0')],
        'cocompany':null,
        'coworkexp':[this.getFielsDefaultValue('coworkexp_id',2)],
        'depre'   :this.getFielsDefaultValue('depre',0),
        'conetsal': [this.getFielsDefaultValue('conetsalary','35000')],
        'codepre' :this.getFielsDefaultValue('codepre',0),
        'coex_emi':[this.getFielsDefaultValue('coex_emi','0')],
        'conature':this.getFielsDefaultValue('conature','Engineer'),
        'cobonus': [this.getFielsDefaultValue('cobonus',0)],

      });
    
  }

  showForm(){}

  getFielsDefaultValue(field,defaultvalue=null){
    var data = this.loanOfferService.getLocalCustomerInfoData(field);
    return (data?data:defaultvalue);
  }
 

  

  setUrlParametersToLocal(params){
    this.loanOfferService.updateCustomerInfoData(
      {   
          "loan_type":this.type,
          "loan_amount":params.loanamount?params.loanamount:this.getFielsDefaultValue('loan_amount',5000000),
          "loan_tenure_id":params.loan_tenure_id,
          "loan_tenure":this.option_loan_tenure[params.loan_tenure_id?params.loan_tenure_id:this.getFielsDefaultValue('loan_tenure_id',1)].name,
          "netsalary":params.netsalary?params.netsalary:this.getFielsDefaultValue('netsalary','35000'),
          "existing_emi":params.emi?params.emi:this.getFielsDefaultValue('existing_emi','5000'),
          "propvalue":params.propvalue?params.propvalue:this.getFielsDefaultValue('propvalue',3000000),
          "salary_bank_account":this.options_bank[params.bank_id?params.bank_id:this.getFielsDefaultValue('salary_bank_account_id',0)].name,
          "salary_bank_account_id":params.bank_id?params.bank_id:this.getFielsDefaultValue('salary_bank_account_id',0),
          "bonus":params.bonus?params.bonus:this.getFielsDefaultValue('bonus',0),
          "emp_type_id":params.emp_type_id,
          "work_exp":this.option_workexp[params.workexp_id?params.workexp_id:this.getFielsDefaultValue('work_exp_id',3)].name,
          "work_exp_id":params.workexp_id,
          "gender":this.options_gender[params.gender_id?params.gender_id:this.getFielsDefaultValue('gender_id',0)].name,
          "gender_id":params.gender_id,
          "location":this.options_locations[params.location_id?params.location_id:this.getFielsDefaultValue('location_id',0)].name,
          "location_id":params.location_id,
          "age":params.age?params.age:this.getFielsDefaultValue('age',28),
          "depre":params.depre, 
          "nature":params.nature,

          "conetsalary":params.conetsal?params.conetsal:this.getFielsDefaultValue('conetsalary','35000'),
          "coex_emi":params.coemi?params.coemi:this.getFielsDefaultValue('coex_emi','0'),
          "cogender_id":params.cogender_id,
          "co_gender":this.options_gender[params.cogender_id?params.cogender_id:this.getFielsDefaultValue('cogender_id','0')],
          "coworkexp":this.option_workexp[params.coworkexp_id?params.coworkexp_id:this.getFielsDefaultValue('coworkexp_id',2)],
          "coworkexp_id":params.coworkexp_id,
          "cobonus":params.cobonus?params.cobonus:this.getFielsDefaultValue('cobonus',0),
          "cobank":this.options_bank[params.cobank_id?params.cobank_id:this.getFielsDefaultValue('cobank_id',0)].name,
          "cobank_id":params.cobank_id,
          "coemp_type_id":params.coemp_type_id,
          "codepre":params.codepre,
          "conature":params.conature,
          "co_employmet_type":this.option_co_employment_type[params.coemp_type_id?params.coemp_type_id:this.getFielsDefaultValue('coemp_type_id',0)].name,
        }
    );
  }

  updateAddCoApplicant(status){
    
    this.is_co_applicant_enabled = status;
    if(this.current_appicant=="Applicant"){
      this.current_appicant="Co Applicant";
    }else{
      this.current_appicant="Applicant";
    }
  }
  RemoveCoApplicant(value){
     this.is_co_applicant_enabled=value;
     this.current_appicant="Applicant"
  }

  // Show Age, Gender and Work exp form : Show / Hide
  updatePersonalize(value){
    this.more_personalize = !this.more_personalize;
  }

 updatePersonalizeMobile(value){
      this.x=false;
      this.hide_personalize=false;
      this.more_personalize_mobile=value;
    // this.carouselindicators.next();
  }

  beforeLoanTypeChange($event: NgbTabChangeEvent){
    if ($event.nextId === emiGlobals.HomeLoan_New) {
      this.type = emiGlobals.HomeLoan_New;
      this.loan_amount_label = "Loan Amount";
      
    }else{
      this.type = emiGlobals.HomeLoan_Transfer;
      this.loan_amount_label = "Loan Outstanding";
    }
    this.activePanel=$event.nextId;
  }

  onTabChange(panel){
    this.activePanel=panel;
    if (panel === emiGlobals.HomeLoan_New) {
      this.type = emiGlobals.HomeLoan_New;
      this.loan_amount_label = "Loan Amount";
    }else{
      this.type = emiGlobals.HomeLoan_Transfer;
      this.loan_amount_label = "Loan Outstanding";
    }
  }

  //this is the search function to get PL company names.
  searchCompanyName(query, callback) {
    this.loanOfferService.searchHomeBankComanyName(query).subscribe((response)=> {
      if (response && response.length !== 0) {
        return callback(response);
      } else {
        return callback();
      }
    });
  }

  fetchHLCompany(event){
    this.company_selected=event;
    
    // this.http.get(`${url}?search=${event.query}`)
    //     .subscribe(response => event.result(response.json()));
    this.loanOfferService.searchHomeBankComanyName(event.query)
      .subscribe((response) =>{
        event.result(response);
        this.company_values=response;
        console.log(response);
      });
      this.checkAddNewItem();
      
  }
  checkAddNewItem(){
    
    console.log(this.company_values);
    return !this.company_values.filter(item => item.includes(this.company_selected)).length;
  }

  onAppEmploymentChange(value){
    
    if(value==0||value==1){
      this.AppEmpType.show_bonus=true;
      this.AppEmpType.show_company=true;
      this.AppEmpType.show_depresation=false;
      this.AppEmpType.show_nature=false;
      this.AppEmpType.bank_title="Salary Account Bank";
      this.AppEmpType.income_title="Net Salary Per Month";
    }else if(value==2){
      this.AppEmpType.show_bonus=false;
      this.AppEmpType.show_company=false;
      this.AppEmpType.show_depresation=true;
      this.AppEmpType.show_nature=false;
      this.AppEmpType.bank_title="Current Account";
      this.AppEmpType.income_title="Net Profit Per Annum";
    }else{
      this.AppEmpType.show_bonus=false;
      this.AppEmpType.show_company=false;
      this.AppEmpType.show_depresation=true;
      this.AppEmpType.show_nature=true;
      this.AppEmpType.bank_title="Current Account";
      this.AppEmpType.income_title="Net Profit Per Annum";
    }
  }

  onCoAppEmploymentChange(value){
    if(value==0||value==1){
      this.CoAppEmpType.show_bonus=true;
      this.CoAppEmpType.show_company=true;
      this.CoAppEmpType.show_depresation=false;
      this.CoAppEmpType.show_nature=false;
      this.CoAppEmpType.bank_title="Salary Account Bank";
      this.CoAppEmpType.income_title="Net Salary Per Month";
    }else if(value==2){
      this.CoAppEmpType.show_bonus=false;
      this.CoAppEmpType.show_company=false;
      this.CoAppEmpType.show_depresation=true;
      this.CoAppEmpType.show_nature=false;
      this.CoAppEmpType.bank_title="Current Account";
      this.CoAppEmpType.income_title="Net Profit Per Annum";
    }else{
      this.CoAppEmpType.show_bonus=false;
      this.CoAppEmpType.show_company=false;
      this.CoAppEmpType.show_depresation=true;
      this.CoAppEmpType.show_nature=true;
      this.CoAppEmpType.bank_title="Current Account";
      this.CoAppEmpType.income_title="Net Profit Per Annum";
    }
  }

  submitForm(values){
   this.onClickOfLoanEligibility.emit("true");
   if(values.sal==0||values.sal==1){
     let queryData={
          loanamount          :values.loanamt,
          loan_tenure_id      :values.tenure,
          netsalary           :values.netsal,
          emi                 :values.ex_emi,
          bank_id             :values.bank,
          work_exp_id         :values.workexp,
          gender_id           :values.gender,
          location_id         :values.city,
          age                 :values.age,
          propvalue           :values.propval,
          bonus               :values.bonus,
          emp_type_id         :values.sal,
          generate_quote      :true,
        };
        if(this.is_co_applicant_enabled&&values.cosal==0||values.cosal==1){
           queryData['conetsal']          =values.conetsal;
           queryData['coemi']             =values.coex_emi;
           queryData['cogender_id']       =values.cogender;
           queryData ['coworkexp_id']    =values.coworkexp;
           queryData['cobonus']           =values.cobonus;
           queryData['cobank_id']         =values.cobank;
           queryData['coemp_type_id']     =values.cosal;
        }
       if(this.is_co_applicant_enabled&&values.cosal==2){
           queryData['conetsal']          =values.conetsal;
           queryData['coemi']             =values.coex_emi;
           queryData['cogender_id']       =values.cogender;
           queryData ['coworkexp_id']    =values.coworkexp;
           queryData['cobank_id']         =values.cobank;
           queryData['coemp_type_id']     =values.cosal;
           queryData['codepre']           =values.codepre;
        }
           if(this.is_co_applicant_enabled&&values.cosal==3||values.cosal==4){
           queryData['conetsal']          =values.conetsal;
           queryData['coemi']             =values.coex_emi;
           queryData['cogender_id']       =values.cogender;
           queryData ['coworkexp_id']    =values.coworkexp;
           queryData['cobank_id']         =values.cobank;
           queryData['coemp_type_id']     =values.cosal;
           queryData['codepre']           =values.codepre;
           queryData['conature']          =values.conature;
        }

        if(this.type=='Home Loan Transfer'){
          this.router.navigate(['/loan/home/transfer'],{
            queryParams:queryData
           });
        }
        if(this.type === 'Home Loan') {
          this.router.navigate(['/loan/home'],{
            queryParams:queryData
           });
        }
        if(this.type=='Home Loan Tax'){
          this.router.navigate(['/loan/home/tax-savings'],{
            queryParams:queryData
           });
        }

        if(this.type === 'Calculator Loan') {
          console.log('---inside type----Calculator Loan', queryData);
          this.router.navigate(['/calculator/savings'], {
            queryParams:queryData
          });
        }

     }else if(values.sal==3||values.sal==4){
       let queryData={
          loanamount          :values.loanamt,
          loan_tenure_id      :values.tenure,
          netsalary           :values.netsal,
          emi                 :values.ex_emi,
          bank_id             :values.bank,
          work_exp_id         :values.workexp,
          gender_id           :values.gender,
          location_id         :values.city,
          age                 :values.age,
          propvalue           :values.propval,
          depre               :values.depre,
          emp_type_id         :values.sal,
          nature              :values.nature,
          generate_quote      :true,
       }
       if(this.is_co_applicant_enabled&&values.cosal==0||values.cosal==1){
           queryData['conetsal']          =values.conetsal;
           queryData['coemi']             =values.coex_emi;
           queryData['cogender_id']       =values.cogender;
           queryData ['coworkexp_id']    =values.coworkexp;
           queryData['cobonus']           =values.cobonus;
           queryData['cobank_id']         =values.cobank;
           queryData['coemp_type_id']     =values.cosal;
        }
       if(this.is_co_applicant_enabled&&values.cosal==2){
           queryData['conetsal']          =values.conetsal;
           queryData['coemi']             =values.coex_emi;
           queryData['cogender_id']       =values.cogender;
           queryData ['coworkexp_id']    =values.coworkexp;
           queryData['cobank_id']         =values.cobank;
           queryData['coemp_type_id']     =values.cosal;
           queryData['codepre']           =values.codepre;
        }
           if(this.is_co_applicant_enabled&&values.cosal==3||values.cosal==4){
           queryData['conetsal']          =values.conetsal;
           queryData['coemi']             =values.coex_emi;
           queryData['cogender_id']       =values.cogender;
           queryData ['coworkexp_id']    =values.coworkexp;
           queryData['cobank_id']         =values.cobank;
           queryData['coemp_type_id']     =values.cosal;
           queryData['codepre']           =values.codepre;
           queryData['conature']          =values.conature;
        }

        if(this.type=='Home Loan Transfer'){
          this.router.navigate(['/loan/home/transfer'],{
            queryParams:queryData
           });
        }
        if(this.type === 'Home Loan') {
          this.router.navigate(['/loan/home'],{
            queryParams:queryData
           });
        }
        if(this.type=='Home Loan Tax'){
          this.router.navigate(['/loan/home/tax-savings'],{
            queryParams:queryData
           });
        }
        if(this.type === 'Calculator Loan') {
          this.router.navigate(['/calculator/savings'], {
            queryParams:queryData
          });
        }

     }else {
        let queryData={
          loanamount          :values.loanamt,
          loan_tenure_id      :values.tenure,
          netsalary           :values.netsal,
          emi                 :values.ex_emi,
          bank_id             :values.bank,
          work_exp_id         :values.workexp,
          gender_id           :values.gender,
          location_id         :values.city,
          age                 :values.age,
          propvalue           :values.propval,
          emp_type_id         :values.sal,
          depre               :values.depre,
          generate_quote      :true,

        }
        if(this.is_co_applicant_enabled&&values.cosal==0||values.cosal==1){
           queryData['conetsal']          =values.conetsal;
           queryData['coemi']             =values.coex_emi;
           queryData['cogender_id']       =values.cogender;
           queryData ['coworkexp_id']    =values.coworkexp;
           queryData['cobonus']           =values.cobonus;
           queryData['cobank_id']         =values.cobank;
           queryData['coemp_type_id']     =values.cosal;
        }
       if(this.is_co_applicant_enabled&&values.cosal==2){
           queryData['conetsal']          =values.conetsal;
           queryData['coemi']             =values.coex_emi;
           queryData['cogender_id']       =values.cogender;
           queryData ['coworkexp_id']    =values.coworkexp;
           queryData['cobank_id']         =values.cobank;
           queryData['coemp_type_id']     =values.cosal;
           queryData['codepre']           =values.codepre;
        }
           if(this.is_co_applicant_enabled&&values.cosal==3||values.cosal==4){
           queryData['conetsal']          =values.conetsal;
           queryData['coemi']             =values.coex_emi;
           queryData['cogender_id']       =values.cogender;
           queryData ['coworkexp_id']    =values.coworkexp;
           queryData['cobank_id']         =values.cobank;
           queryData['coemp_type_id']     =values.cosal;
           queryData['codepre']           =values.codepre;
           queryData['conature']          =values.conature;
        }
       if(this.type=='Home Loan Transfer'){
          this.router.navigate(['/loan/home/transfer'],{
            queryParams:queryData
           });
        }
        if(this.type === 'Home Loan') {
          this.router.navigate(['/loan/home'],{
            queryParams:queryData
           });
        }
        if(this.type=='Home Loan Tax'){
          this.router.navigate(['/loan/home/tax-savings'],{
            queryParams:queryData
           });
        }
        if(this.type === 'Calculator Loan') {
          this.router.navigate(['/calculator/savings'], {
            queryParams:queryData
          });
        }
     }
  
  }
  generateOffer(params){
    console.log(this.loanApplyForm.value);
      if(this.validate()){
        try {
          
              
          // let values_workexp =  (values.workexp?values.workexp:0);
          let dataToApi           = Object.assign({});

          dataToApi['sal']           = this.option_co_employment_type[params.emp_type_id].value;
          dataToApi['bank']          = this.options_bank[params.bank_id].value;
          dataToApi['tenure']        = this.option_loan_tenure[params.loan_tenure_id].value;
          dataToApi['workexp']       = this.option_workexp[params.work_exp_id].value;
          dataToApi['city']          = this.options_locations[params.location_id].value;
          dataToApi['gender']        = this.options_gender[params.gender_id].value;
          if(this.type === 'Calculator Loan') {
            dataToApi['loan_type']     = 'Home Loan';
          }else {
            dataToApi['loan_type']     = this.type;
          }
          
          dataToApi['netsal']        = params.netsalary;
          dataToApi['age']           = params.age;
          dataToApi['bonus']         = params.bonus;
          dataToApi['loanamt']       = params.loanamount;
          dataToApi['tenure']        = this.option_loan_tenure[params.loan_tenure_id].value;
          dataToApi['propval']       = params.propvalue;
          dataToApi['nature']        = params.nature?params.nature:this.getFielsDefaultValue('nature','Engineer');
          dataToApi['depre']         = params.depre?params.depre:this.getFielsDefaultValue('depre',0);
          dataToApi['ex_emi']        = params.emi;
          dataToApi['company']       = this.loanApplyForm.value.company;




          if(this.is_co_applicant_enabled){
            dataToApi['coworkexp']     = this.option_workexp[params.coworkexp_id].value;
            dataToApi['cogender']      = this.options_gender[params.cogender_id].value;
            dataToApi['cobank']        = this.options_bank[params.cobank_id].value;
            dataToApi['cosal']         = this.option_co_employment_type[params.coemp_type_id].value;

            dataToApi['cocompany']     = this.loanApplyForm.value.cocompany; 
            dataToApi['conetsal']      = params.conetsal;
            dataToApi['codepre']       = params.codepre;
            dataToApi['coex_emi']      = params.coemi;
            dataToApi['connature']     = params.conature;
            dataToApi['cobonus']       = params.cobonus;
          }
          // }else{
          //   delete dataToApi.coworkexp;
          //   delete dataToApi.cogender;
          //   delete dataToApi.cobank;
          //   delete dataToApi.cocompany;
          //   delete dataToApi.codepre;
          //   delete dataToApi.coex_emi;
          //   delete dataToApi.conature;
          //   delete dataToApi.conetsal;
          //   delete dataToApi.cosal;
          //   delete dataToApi.cobonus;
            
          // }

          this.loan_amount_generated=true;
          this.dataToApi = dataToApi;

          dataToApi['pid']           = this.getPid('form');
          dataToApi['purp']         = this.getPurposeCode();
          //dataToApi.sal           = this.getSalType();
          console.log(dataToApi);
          this.loanOfferService.generateHLCommonOffer(dataToApi);
          return null;
          
        } catch (error) {
          console.log(error);
        }
      }

  }
       
    // }
  
     
  

  eligibiliityCheck(type:string,amount:string){
    debugger
    let refine_amount;
    refine_amount= amount.replace(/,\s?/g, "");
    this.dataToApi.loanamt  = refine_amount;
    this.dataToApi.pid      = this.getPid('form');
    this.dataToApi.purp     = this.getPurposeCode();
    //this.dataToApi.sal     = this.getSalType(); 
    this.loanOfferService.generateHLCommonOffer(this.dataToApi);

  }

  getPid(tag:string){
    let purp  = this.type;
    let pid = 1;
    let emp_type = ((this.dataToApi.sal==0 ||this.dataToApi.sal==1 ||this.dataToApi.sal==2)?'Salaried':'Non Salaried');

    console.log("sal "+emp_type);
    console.log("sal "+this.dataToApi.sal);
    //Salaried New loan
    //      if(tag=="form" && purp == emiGlobals.HomeLoan_New){ pid = 1; }
    // else if(tag=="income" && purp == emiGlobals.HomeLoan_New){ pid = 2; }
    // else if(tag=="property" && purp == emiGlobals.HomeLoan_New){ pid = 3; }
    // Balance Transfer Non Salaried
    if(emp_type== "Non Salaried" && tag=="form" ){ pid = 4; }
    else if(emp_type== "Non Salaried" && tag=="income" ){ pid = 5; }
    else if(emp_type== "Non Salaried" && tag=="property"  ){ pid = 6; }

    // Balance Transfer Salaried
    /* No option to insert data in specidied api back end in EMI1, So offers are comming from Non salaried*/
    else if(emp_type== "Salaried" && tag=="form" ){ pid = 1; } 
    else if(emp_type== "Salaried" && tag=="income" ){ pid = 2; }
    else if(emp_type== "Salaried" && tag=="property"  ){ pid = 3; } 
    
    return pid;
  }

  getPurposeCode(){
     let loan_type  = this.type;
     if(loan_type==emiGlobals.HomeLoan_New){
      // return 6;
      return 1;
     }
    return 6;
  }

  getSalType(){
    if(this.type!=emiGlobals.HomeLoan_New){
      // Temporary since no backend for Salaried Balance Trasfer Option.
      let sal = ((this.dataToApi.sal==0 ||this.dataToApi.sal==1||this.dataToApi.sal==2)?3:this.dataToApi.sal);
      return sal;
    }
    return this.dataToApi.sal;
  }

  toggleApplicant(){
    
    if(this.is_co_applicant_enabled){
      if(this.current_appicant=="Applicant"){
        this.current_appicant="Co Applicant";
      }else{
        this.current_appicant="Applicant";
      }
    }
  }


  validate(){
    if(this.AppEmpType.status=="Salaried"){
      if(!this.loanApplyForm.value['company']){
        this.loanApplyForm.value['company']="no-company";
      }
    }
    return true;
  }
  onNoOptionsFound(searchTerm: string) {
    this.noResultsTerm = searchTerm;
}
}




// WEBPACK FOOTER //
// ./src/app/loan/hl-form/hl-form.component.ts